import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { t } from 'ttag';

import { Heading } from '@components';
import { Breadcrumbs } from '@modules';

import { Banners, Categories, Questions, Unibot } from '../components';

export default function FAQ() {
  const history = useHistory();

  const handleHistoryPush = useCallback(
    (event, url) => {
      event.preventDefault();
      history.push(url);
    },
    [history]
  );

  return (
    <div className="min-h-screen bg-whisper pb-8 md:pb-16">
      <div className="container space-y-8 px-0 py-4 sm:px-2 sm:py-8 md:space-y-16">
        <section>
          <Breadcrumbs>
            <Breadcrumbs.Breadcrumb href="/">{t`Frontpage`}</Breadcrumbs.Breadcrumb>

            <Breadcrumbs.Breadcrumb
              href="/faq/"
              isActive
              onClick={event => handleHistoryPush(event, '/')}
            >
              {t`FAQ`}
            </Breadcrumbs.Breadcrumb>
          </Breadcrumbs>
          <Heading as="h1" className="font-black md:col-span-2">
            {t`Frequently Asked Questions`}
          </Heading>
          <Unibot />
          <Banners />
        </section>
        <main className="space-y-8">
          <Heading as="h2" className="break-words text-3xl normal-case">
            {t`How can we help you?`}
          </Heading>
          <div className="space-y-8 lg:grid lg:grid-cols-3 lg:gap-16 lg:space-y-0">
            <section className="space-y-4 lg:col-span-2">
              <Categories />
            </section>
            <section className="space-y-4 lg:col-span-1">
              <Heading as="h2" className="break-words font-black">
                {t`Popular Questions`}
              </Heading>
              <Questions isPopular />
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}
